import { Subject, BehaviorSubject } from 'rxjs';
var DiagramService = /** @class */ (function () {
    function DiagramService() {
        this._diagram$ = new BehaviorSubject({});
        this._nodeUpdated$ = new BehaviorSubject(false);
        this._addNode$ = new Subject();
        this._updateNode$ = new Subject();
        this._deleteNode$ = new Subject();
        this._markDeletableNodes$ = new BehaviorSubject('');
        this._autoSave$ = new Subject();
        this._adjustPositionY$ = new Subject();
    }
    Object.defineProperty(DiagramService.prototype, "diagram$", {
        get: function () {
            return this._diagram$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagramService.prototype, "markDeletableNodes$", {
        get: function () {
            return this._markDeletableNodes$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagramService.prototype, "nodeUpdated$", {
        get: function () {
            return this._nodeUpdated$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagramService.prototype, "addNode$", {
        get: function () {
            return this._addNode$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagramService.prototype, "updateNode$", {
        get: function () {
            return this._updateNode$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagramService.prototype, "deleteNode$", {
        get: function () {
            return this._deleteNode$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagramService.prototype, "autoSave$", {
        get: function () {
            return this._autoSave$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiagramService.prototype, "adjustPositionY$", {
        get: function () {
            return this._adjustPositionY$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    DiagramService.prototype.setAdjustPositionY = function (elem) {
        this._adjustPositionY$.next(elem);
    };
    DiagramService.prototype.setParams = function (params) {
        this._diagram$.next(params);
    };
    DiagramService.prototype.isNodeUpdated = function () {
        this._nodeUpdated$.next(true);
    };
    DiagramService.prototype.addNewNode = function (parentId, node) {
        this._addNode$.next({
            parentId: parentId,
            node: node,
        });
    };
    DiagramService.prototype.updateNode = function (id, node) {
        this._updateNode$.next({
            id: id,
            node: node,
        });
    };
    DiagramService.prototype.deleteNode = function (parentId, index) {
        if (index === void 0) { index = 0; }
        this._deleteNode$.next({
            parentId: parentId,
            index: index,
        });
    };
    DiagramService.prototype.markDeletableNodes = function (id) {
        this._markDeletableNodes$.next(id);
    };
    DiagramService.prototype.autoSave = function (doSave) {
        this._autoSave$.next(doSave);
    };
    return DiagramService;
}());
export { DiagramService };
